const menu = document.getElementById('mainMenu'),
      burger = document.getElementById('hamburger')

export default function() {
  burger.addEventListener('click', () => {
    menu.classList.toggle('active')
    burger.classList.toggle('is-active')
  })
}